import Marquee from "react-fast-marquee";

const ITEMS = [
  "27 Years HR Experience",
  "ORS 652.220 Experts",
  "Public Sector Leadership",
  "Comparator-Based Wage Studies",
  "Oregon-Grounded",
  "Fractional HR Director",
];

export const CredibilityMarquee = () => (
  <div data-testid="credibility-marquee" className="border-y border-forest-700 bg-forest-800/70 py-8">
    <Marquee speed={35} gradient={false} autoFill>
      {ITEMS.map((item, i) => (
        <div key={i} className="flex items-center">
          <span className="font-serif italic text-3xl md:text-5xl text-sage-200/60 px-10">{item}</span>
          <span className="text-golden-500 text-2xl">&#10022;</span>
        </div>
      ))}
    </Marquee>
  </div>
);
